import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const AuthRequiredRoute = ({ auth, component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth) {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: props.location },
              }}
            />
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};

AuthRequiredRoute.propTypes = {
  auth: PropTypes.bool,
  component: PropTypes.func,
  location: PropTypes.object,
};

export default AuthRequiredRoute;



// WEBPACK FOOTER //
// src/components/shared/AuthRequiredRoute.jsx